export const GIFT_CARD_FIELDS = {
    giftCardFields(status) {
        return [{
            type: 'number',
            name: 'purchaseOrderId',
            label: '_purchase_order_id_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {},
            validationError: '',
            validationErrors: ''
        }, {
            type: 'text',
            name: 'name',
            label: '_owner_name_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {},
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_'
            }
        }, {
            type: 'text',
            name: 'phone',
            label: '_owner_phone_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {
                isNumeric: true,
            },
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_',
                isNumeric: '_error_numeric_'
            }
        }, {
            type: 'date',
            name: 'soldDate',
            label: '_sold_date_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {},
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_'
            }
        },
        {
            type: 'date',
            name: 'activationDate',
            label: '_activation_date_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {},
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_'
            }
        }, {
            type: 'date',
            name: 'endDate',
            label: '_end_date_',
            inputType: 0,
            required: false,
            disabled: true,
            validations: {},
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_'
            }
        }, {
            type: 'text',
            name: 'initialBalance',
            label: '_initial_balance_',
            inputType: 0,
            required: true,
            disabled: true,
            validations: {
                isNumeric: true,
            },
            validationError: '',
            validationErrors: {
                isDefaultRequiredValue: '_required_field_',
                isNumeric: '_error_numeric_'
            }
        }, {
            type: 'number',
            name: 'currentBalance',
            label: '_current_balance_',
            inputType: 0,
            required: true,
            disabled: true,
            validations: {
                isNumeric: true,
            },
        }];
    }
}
